module.exports = __webpack_public_path__ + "static/img/4962_phase_function_Paper_PointsHejduk_Prediction.d41ef26.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/4962_phase_function_Paper_PointsHejduk_Prediction.png
// module id = WbrU
// module chunks = 0